import styled from 'styled-components'

export const Blockquote = styled.blockquote`
  font-size: 1.2rem;
  font-style: italic;
  line-height: 1.5;
  border-left: 0.2rem solid ${props => props.theme.colors.primary};
  padding-left: 0.5rem;
`
